module.exports = __webpack_public_path__ + "static/fonts/SCDream5.1880d20.woff";